import { render } from "./AIStabilizationAndGrowthFramework.vue?vue&type=template&id=5ced6fd2"
import script from "./AIStabilizationAndGrowthFramework.vue?vue&type=script&lang=js"
export * from "./AIStabilizationAndGrowthFramework.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__